import { Box, Chip, Popover, PopoverProps, Stack, Typography } from "@mui/material";

import AppAvatar from "@/common/components/Avatar/AppAvatar";
import CustomerLink from "@/common/components/Entity/Customer/CustomerLink";
import { useUserProfile } from "@/common/hooks/user/useUserProfile";
import { UserDto } from "@/core/api/generated/v1";

interface Props extends PopoverProps {
  user?: UserDto;
}

export default function UserPopover({ user, ...popoverProps }: Props) {
  const profile = useUserProfile();

  const isMe = user && user?.id === profile?.id;

  return (
    <Popover
      sx={{
        pointerEvents: "none",
      }}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      disableRestoreFocus
      {...popoverProps}
    >
      <Box sx={{ minWidth: "300px", maxWidth: { sm: "95vw", md: "400px" }, p: 2 }}>
        <Stack direction='row' spacing={2}>
          <AppAvatar size='medium' user={user} withPopover={false} />

          <Box>
            <Typography component='div' variant='subtitle1'>
              {user?.personName?.name}{" "}
              {isMe && (
                <Chip size='small' color='primary' variant='outlined' label='You' sx={{ ml: 1 }} />
              )}
            </Typography>

            <Typography component='div' variant='body1'>
              {user?.email}
            </Typography>

            <Typography component='div' variant='body1'>
              {user?.phoneNumber}
            </Typography>

            {user?.isCustomerUser && user?.customerId && (
              <Stack direction='row' gap={1} sx={{ flexWrap: "wrap" }}>
                <Chip variant='outlined' size='small' color='default' label='Customer' />

                <Chip
                  variant='outlined'
                  size='small'
                  color='default'
                  label={<CustomerLink entityId={user.customerId} entity={undefined} />}
                />
              </Stack>
            )}
          </Box>
        </Stack>
      </Box>
    </Popover>
  );
}
